import { CANLI_BILGILENDIRME_SURUMU } from "@koclukpanel/contracts";
import { CanliIzlemeBilgilendirme, Kart } from "@koclukpanel/ui";

/**
 * CANLI ÇALIŞMA İZLEME BİLGİLENDİRMESİ — panel (F-LIV-07)
 *
 * Giriş yapmış HER personel açabilir: izin sormuyor, çünkü bu bir yetki değil bir BİLGİLENDİRME
 * (kim neyi görüyor, ne kaydediliyor). Listeyi göremeyen biri de öğrencilerinin neyi paylaştığını
 * bilmeli. Metin salt okunur, rıza/onay düğmesi YOK ve genel aydınlatma metninin yeni sürümü değil
 * (F-LIV-08); metin ve sürümü paylaşılan bileşenden geliyor, burada kopyası yok.
 */
export function CanliBilgilendirme() {
  return (
    <Kart className="max-w-3xl">
      <CanliIzlemeBilgilendirme surum={CANLI_BILGILENDIRME_SURUMU} />
    </Kart>
  );
}
